import { Title } from "./styled";
const Header = ({ title }) => (
  <header>
    <Title>{title}</Title>
  </header>
);
export default Header;
